
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import $ from "jquery";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import AdminLogin from "./pages/AdminLogin";
import ContactListings from "./pages/ContactListings";
import BlogManagement from "./pages/BlogManagement";
import BlogEditor from "./pages/BlogEditor";
import BlogPreview from "./pages/BlogPreview";
import VisitorListings from "./pages/VisitorListings";
import WhatsAppSettings from "./pages/WhatsAppSettings";
import ProtectedRoute from "./components/ProtectedRoute";
import { AdminLeaveProvider } from "./components/AdminLeave";

function App() {
  return (
   <>
     <Router basename='/'> 
         {/* {window.location.pathname !== '/nova' && <Sidebar />}
        <Sidebar/> */}
            <AdminLeaveProvider>
            <Routes> 
                <Route path="/" element={<Home />} />  
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/Admin" element={<AdminLogin />} />
                <Route 
                  path="/Admin/Contacts" 
                  element={
                    <ProtectedRoute>
                      <ContactListings />
                    </ProtectedRoute>
                  } 
                />
                <Route
                  path="/Admin/Blog"
                  element={
                    <ProtectedRoute>
                      <BlogManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/Admin/Blog/new"
                  element={
                    <ProtectedRoute>
                      <BlogEditor />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/Admin/Blog/edit/:id"
                  element={
                    <ProtectedRoute>
                      <BlogEditor />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/Admin/WhatsApp"
                  element={
                    <ProtectedRoute>
                      <WhatsAppSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/Admin/Visitors"
                  element={
                    <ProtectedRoute>
                      <VisitorListings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/Admin/Blog/preview/:id"
                  element={
                    <ProtectedRoute>
                      <BlogPreview />
                    </ProtectedRoute>
                  }
                />
                {/* <Route path="/ManualCompanies" element={<ManualCompanies />} />     */}
                
            </Routes>
            </AdminLeaveProvider>
        </Router>     
   </>
  );
}

export default App;
